 {
    "common": {
    "thisWeek": "This week",
    "lastWeek": "Last week",
    "lastNumberOfDays": "Last {numberOfDays} days",
    "thisMonth": "This month"
    },
    "subAccounts": "Sub-accounts",
    "submitFeedback": "Submit feedback",
    "createSubAccount": "Create sub-account",
    "viewScheduleReports": "View scheduled reports",
    "searchSubAccount": "Search by sub-account",
    "columns": "Columns",
    "sortBy": "Sort by",
    "selectColumns": "Select columns",
    "maxColumns": "Max 8 columns at a time",
    "applyColumns": "Apply columns",
    "activeUsers": "Active users",
    "appointments": "Appointments",
    "contacts": "Contacts",
    "emails": "Emails",
    "textMessages": "Text messages",
    "calls": "Calls",
    "submissions": "Submissions",
    "reviews": "Reviews",
    "sitesCreated": "Sites created",
    "name": "Name",
    "formSubmissions": "Form submissions",
    "surveySubmissions": "Survey submissions",
    "facebookFormSubmissions": "Facebook form submissions",
    "funnels": "Funnels",
    "websites": "Websites",
    "forms": "Forms",
    "surveys": "Surveys",
    "highestFirst": "Highest first",
    "lowestFirst": "Lowest first",
    "orderBy": "Order by",
    "noMoreLocations": "No more locations found",
    "preparingReport": "We are preparing your report…",
    "preparingReportDesc": "Don't close or reload this window while the export is in progress.",
    "outOf": "out of",
    "subAccountsExported": "Sub-accounts exported",
    "close": "Close",
    "scheduledForDeletion": "Scheduled for deletion",
    "readyToSell": "Ready to sell",
    "closedWon": "Closed (won)",
    "wpSaleSuccessful": "WordPress sale is successful",
    "wpNotSold": "WordPress not sold yet",
    "yxtSaleSuccessful": "Yext sale is successful",
    "yxtNotSold": "Yext not sold yet",
    "saasSubInactive": "SaaS subscription is inactive",
    "saasSubTrialing": "SaaS subscription is trialing",
    "saasSubActive": "SaaS subscription is active",
    "emailRebillingActive": "Email rebilling is active",
    "emailRebillingInactive": "Email rebilling is inactive",
    "twilioRebillingActive": "Twilio rebilling is active",
    "twilioRebillingInactive": "Twilio rebilling is inactive",
    "wpRebillingActive": "WhatsApp rebilling is active",
    "wpRebillingInactive": "WhatsApp rebilling is inactive",
    "saasModeActivated": "SaaS mode is activated",
    "paymentPending": "Payment is pending",
    "saasModeNotActivated": "SaaS mode is not activated",
    "managedByLCPhone": "Managed by LC Phone",
    "migrationToLCPhone": "Under migration to LC Phone",
    "notManagedByLCPhone": "Not managed by LC Phone",
    "managedByLCEmail": "Managed by LC Email",
    "notMangedByLCEmail": "Not managed by LC Email",
    "remainingWalletBalance": "Remaining wallet balance of this SaaS location",
    "reports": "Reports",
    "switchToSubAccount": "Switch to sub-account",
    "manageClient": "Manage client",
    "subAccountDeletedIfChangedMind": "This sub-account will be deleted on {time}, if you've changed your mind",
    "subAccountDeletedInMinute": "This sub-account will be deleted within the next minute",
    "changedMind": "if you've changed your mind",
    "clickHere": "Click here",
    "subAccountPaused": "This sub-account is paused. Your clients can't log in, but the agency can. To resume this account",
    "subAccountRestricted": "This sub-account is paused due to pending approval.",
    "subAccountVerificationPending": "This sub-account is paused due to pending email and phone verification from sub-account admin.",
    "subAccountDeclined": "This sub-account is paused due to declined approval request. You can still resume this sub-account from ",
    "here": "here.",
    "reviewAndResume": "to review and resume this sub-account.",
    "incomingCalls": "Incoming calls",
    "outgoingCalls": "Outgoing calls",
    "totalTalktime": "Total talktime",
    "incomingEmails": "Incoming emails",
    "outgoingEmails": "Outgoing emails",
    "incomingSms": "Incoming text messages",
    "outgoingSms": "Outgoing text messages",
    "contactsCreated": "Total contacts created",
    "appointmentsBooked": "Total appointments booked",
    "totalFormSubmissions": "Total form submissions",
    "totalSurveySubmissions": "Total survey submissions",
    "totalFacebookFormSubmissions": "Total Facebook form submissions",
    "incomingGMBMessages": "Incoming GBP messages",
    "outgoingGMBMessages": "Outgoing GBP messages",
    "gmbMessages": "GBP messages",
    "fbMessages": "Facebook messages",
    "incomingFbMessages": "Incoming Facebook messages",
    "outgoingFbMessages": "Outgoing Facebook messages",
    "igMessages": "Instagram messages",
    "incomingIgMessages": "Incoming Instagram messages",
    "outgoingIgMessages": "Outgoing Instagram messages",
    "totalReviews": "Total reviews",
    "positiveReviews": "Positive reviews",
    "negativeReviews": "Negative reviews",
    "back": "Back",
    "selectDashboards": "Select dashboards",
    "next": "Next",
    "backToSubAccounts": "Back to sub-accounts",
    "pauseSchedule": "Pause schedule",
    "resumeSchedule": "Resume schedule",
    "editSchedule": "Edit schedule",
    "addSchedule": "Add schedule",
    "selectReportToAdd": "Select reports to add in the email",
    "selectAll": "Select all",
    "pauseScheduleConfirm": "Are you sure you want to pause the report schedule?",
    "resumeScheduleConfirm": "Are you sure you want to resume the report schedule?",
    "tasks": "Tasks",
    "conversations": "Conversations",
    "users": "Users",
    "dealOverview": "Deal overview",
    "confirmAction": "Confirm action",
    "yes": "Yes",
    "no": "No",
    "reportDetails": "Report details",
    "reportCreatedOn": "Report created on",
    "searchByEmail": "Search by email",
    "lastActivity": "Last activity",
    "noRecords": "No records found",
    "scheduleReport": "Schedule report",
    "schedule": "Schedule",
    "save": "Save",
    "emailSubject": "Email subject",
    "frequency": "Frequency",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "nextScheduleDate": "Next schedule date",
    "startingOn": "Starting on",
    "timeOfDay": "Time of day",
    "reportsToTimezone": "Report will be sent in the sub-account's timezone",
    "selectRecipients": "Select recipients",
    "invalidEmail": "Enter a valid email address.",
    "testEmail": "Test email",
    "selectTestRecipients": "Select test recipients",
    "setupSubject": "Set up the subject above to test the report",
    "sendTest": "Send test",
    "scheduleSimilarSchedules": "Schedule similar report for other sub-accounts",
    "accountSummary": "Account summary",
    "scheduleList": "Schedule list",
    "subAccountName": "Sub-account name",
    "nextRunDate": "Next run date",
    "reportSectionsAdded": "Report sections added",
    "status": "Status",
    "scheduleAction": "Schedule action",
    "cancel": "Cancel",
    "pleaseWait": "Loading…",
    "confirm": "Confirm",
    "booked": "Booked",
    "confirmed": "Confirmed",
    "showed": "Showed",
    "noShow": "No-show",
    "cancelled": "Cancelled",
    "unread": "Unread",
    "engagement": "Engagement",
    "reaction": "Reaction",
    "deliverySummary": "Delivery summary",
    "successfulDelivery": "Successful delivery",
    "opened": "Opened",
    "clicked": "Clicked",
    "replied": "Replied",
    "unsubscribed": "Unsubscribed",
    "complained": "Complained",
    "failed": "Failed",
    "bounced": "Bounced",
    "open": "Open",
    "won": "Won",
    "abandoned": "Abandoned",
    "lost": "Lost",
    "sent": "Sent",
    "eject": "Eject",
    "delivered": "Delivered",
    "faceBookLeadForm": "Facebook lead form",
    "overdue": "Overdue",
    "reviewsReceived": "Reviews received",
    "formBuilders": "Form builders",
    "switchToSaaS": "Switch to SaaS",
    "numberOfContacts": "Total contacts",
    "numberOfAppointments": "Total appointments",
    "outreach": "Outreach",
    "notSubAccountUser": "Not a sub-account user",
    "searchSubAccName": "Search by sub-account's name",
    "recipients": "Recipients",
    "scheduleCreated": "Email report schedule created for ",
    "scheduleUpdated": "Email report schedule updated for ",
    "scheduleNotCreated": "Email report schedule could not be created for",
    "scheduleNotUpdated": "Email report schedule could not be updated for",
    "total": "Total",
    "inbound": "Inbound",
    "outbound": "Outbound",
    "totalEmails": "Total emails",
    "inboundEmails": "Inbound emails",
    "outboundEmails": "Outbound emails",
    "totalTextMessages": "Total text messages",
    "inboundTextMessages": "Inbound text messages",
    "outboundTextMessages": "Outbound text messages",
    "totalCalls": "Total calls",
    "inboundCalls": "Inbound calls",
    "outboundCalls": "Outbound calls",
    "faceBookLeadFormSubmissions": "Facebook lead form submissions",
    "inboundGMBMessages": "Inbound GBP messages",
    "outboundGMBMessages": "Outbound GBP messages",
    "totalIgMessages": "Total Instagram messages",
    "inboundIgMessages": "Inbound Instagram messages",
    "outboundIgMessages": "Outbound Instagram messages",
    "totalfbMessages": "Total Facebook messages",
    "inboundfbMessages": "Inbound Facebook messages",
    "outboundfbMessages": "Outbound Facebook messages",
    "sitesCreatedFunnels": "Sites created - funnels",
    "sitesCreatedActiveFunnels": "Sites created - active funnels",
    "sitesCreatedWebsites": "Sites created - websites",
    "sitesCreatedActiveWebsites": "Sites created - active websites",
    "sitesCreatedForms": "Sites created - forms",
    "sitesCreatedActiveForms": "Sites created - active forms",
    "sitesCreatedSurveys": "Sites created - surveys",
    "sitesCreatedActiveSurveys": "Sites created - active surveys",
    "googleReviews": "Google reviews",
    "facebookReviews": "Facebook reviews",
    "inboundCallDuration": "Inbound call duration (hours)",
    "outboundCallDuration": "Outbound call duration (hours)",
    "pleaseSelect": "Select",
    "subAccountIsDeleted": "This sub-account has been deleted",
    "subAccountIsPaused": "This sub-account has been paused",
    "success": "Success",
    "error": "Error",
    "testEmailSent": "Test email sent",
    "testEmailNotSent": "Test email could not be sent",
    "reviewRequest": "Review requests",
    "pendingTransferDescription": "Other agencies have requested to transfer sub-accounts to you.",
    "pendingTransferHeading": "You've got pending sub-account transfer requests.",
    "subAccountTransfer": "Sub-account transfers",
    "manageSubAccTransfer": "Manage your sub-account transfer requests",
    "subAccRequest": "Sub-account {tabName} requests",
    "receive": "Receive",
    "send": "Send",
    "release": "Release",
    "requests": "{count} requests",
    "subAccLimit": "Sub-accounts usage limit reached.",
    "subAccPlanLimit": "You have used 3/3 sub-accounts allowed under your current plan.",
    "upgradeTime": "It's time for an upgrade!",
    "upgradeHigher": "Upgrade to a higher plan to accept the sub-account transfer.",
    "browse": "Browse plans",
    "pendingTransferTitle": "A transfer request for this sub-account is already pending.",
    "unableTransfer": "Unable to transfer sub-account to this agency.",
    "unableEjectCancel": "Unable to cancel the sub-account eject request.",
    "EjectErrorDetails": "The sub-account eject request can't be cancelled.",
    "hippaErrorDescription": "This sub-account is HIPAA enabled and can't be transferred to a non-HIPAA agency.",
    "pendingTransferErrorDescription": "Cancel the existing transfer request for this sub-account before creating a new one.",
    "receivingAgency": "Receiving agency",
    "releasingAgency": "Releasing agency",
    "noOfContacts": "Total contacts",
    "requestedDate": "Requested date",
    "action": "Action",
    "cancelTransfer": "Cancel transfer",
    "decline": "Decline",
    "cancelTransferRequest": "Cancel sub-account transfer request?",
    "cancelEjectRequest": "Cancel sub-account eject request?",
    "cancelRequestDescription": "The receiving agency will no longer see this transfer request, and the sub-account {name} will not be transferred.",
    "cancelEjectRequestDescription": "The selected user will no longer be able to create new agency out of the sub-account {name}.",
    "declineRequest": "Decline sub-account transfer request?",
    "declineRequestDescription": "The request will be declined and the sub-account {name} won't be transferred to your agency.",
    "approveTransfer": "Approve sub-account transfer to your agency?",
    "approveTransferDescription": "{name} sub-account will be transferred to your agency.",
    "transferNow": "Transfer now",
    "cancelNow": "Cancel now",
    "transferErrorDetails": "This sub-account can't be transferred.",
    "cancelRequest": "Cancel request",
    "received": "Received",
    "approve": "Approve",
    "goBack": "Go back",
    "done": "Done",
    "subAccountTransferred": "The sub-account has been successfully transferred!",
    "subAccountTransferDescription": "Even though the sub-account has been transferred, some assets like users, phone numbers, Mailgun accounts, and Yext listings may still take 10–15 minutes to reflect in the destination.",
    "activeSubscriptionsAlert": "The location has active subscriptions. Please cancel all subscriptions before transferring the location. List of active subscriptions: {subscriptions}",
    "isSaasEnabled": "SaaS enabled",
    "typeToSearch": "Type to search",
    "dateAdded": "Date added",
    "emailEngagement": "Email engagement",
    "emailReaction": "Email reaction",
    "emailDeliverySummary": "Email delivery summary",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Account summary - {subAccountName}",
    "test": "Test",
    "scheduleExists": "Schedule exists",
    "aToZ": "A - Z",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Only admin users can add new sub-accounts.",
    "locationName": "Location name",
    "transferCompleted": "Transfer request for this location is already processed. Refresh the page.",
    "unauthorizedTransfer": "You are not authorized to perform this action. Only agency owners can perform this action.",
    "bulkLocationTransfer": "Bulk transfer sub-accounts",
    "singleRequest": "Single request",
    "bulkRequest": "Bulk request",
    "backToLocationTransfer": "Back to location transfer",
    "initiateBulkTransfer": "Initiate bulk sub-account transfer",
    "initiateBulkTransferDescription": "Select the sub-accounts you want to transfer, or enter their IDs separated by commas.",
    "subAccountId": "Sub-account ID",
    "selectFromList": "Select from list",
    "addManually": "Add manually",
    "accountsSelected": "{count} selected",
    "selectAllSubAccounts": "Select all",
    "removeAll": "Remove all",
    "addManualLocations": "Add location IDs separated by commas",
    "manualAllLocationIds": "Location IDs of the sub-accounts you wish to transfer, separated by commas.",
    "enterLocationIds": "Enter location IDs",
    "selectSubAccounts": "Select sub-accounts and transfer to an existing agency",
    "subAccountTransferWarning": "All sub-account assets and users will get transferred.",
    "proceed": "Proceed",
    "bulkRequestSubmitted": "Bulk transfer request submitted",
    "bulkRequestSubmittedDescription": "Each sub-account will be transferred once the receiving agency accepts the transfer request. You can track the status of the request on the ❝{pagename}❞ page. (provided they are eligible)",
    "bulkTransferRequestFailed": "Bulk transfer request failed",
    "errorLocations": "Sub-accounts with error",
    "viewDetails": "View details",
    "somethingWrong": "Something went wrong. Try again.",
    "confirmBulkRequest": "Confirm bulk transfer request?",
    "bulkTransferAccounts": "Bulk transfer '{count}' selected sub-accounts?",
    "confirmDetails": "Confirm details before transferring.",
    "transferConsent": "I have read and understood the above guide and consent to all the limitations.",
    "transferInfo": "Sub-account transfer is subject to the receiving agency accepting it into their account.",
    "receivingRelNo": "Receiving agency's relationship number",
    "enterRelNo": "Enter relationship number",
    "transferConfirmation": "Upon completing this action, the bulk transfer request will be sent to the receiving agency ({ relNo }). Each sub-account you've selected will be transferred once the receiving agency accepts it. Please note that this action is irreversible for all sub-accounts included in the transfer.",
    "confirmPassword": "Confirm by typing password below",
    "enterPassword": "Enter password",
    "requestTransfer": "Request transfer",
    "confirmTransfer": "Confirm transfer",
    "notNow": "Not now",
    "invalidRelNo": "Invalid relationship number",
    "invalidPassword": "Invalid password.",
    "searchSubAccounts": "Search sub-accounts",
    "searchSubAccountsId": "Search sub-account ID",
    "takeAction": "Take action",
    "sub_account_details": "Sub-account details",
    "no_of_contacts": "Total contacts",
    "transfer_status": "Transfer status",
    "error_info": "Error info",
    "bulk_transfer_status": "Bulk sub-account transfer status",
    "pending": "Pending",
    "processed": "Processed",
    "reject_all": "Reject all",
    "accept_all": "Accept all",
    "cancel_all": "Cancel all",
    "clearAll": "Clear all",
    "refresh": "Refresh",
    "rejected": "Rejected",
    "decline_transfer": "Decline transfer",
    "decline_bulk_transfer": "Decline bulk sub-account transfer request?",
    "decline_bulk_transfer_description": "The request will be declined and the {length} sub-accounts won't be transferred to your agency.",
    "accept_bulk_transfer": "Accept bulk sub-account transfer request?",
    "accept_bulk_transfer_description": "The request will be accepted and the {length} sub-accounts will be transferred to your agency.",
    "cancel_bulk_transfer": "Cancel bulk transfer?",
    "cancel_bulk_transfer_description": "Are you sure you want to cancel this bulk transfer of {length} sub-accounts to “{name}”?",
    "consent_sub_account_transfer": "Please read and consent to {link}",
    "sub_account_transfer_guidelines": "Sub-account transfer guidelines",
    "valid_rel": "Enter valid relationship number",
    "something_went_wrong": "Something went wrong. Try again.",
    "export": "Export",
    "export_success": "The data that you requested is being processed. You will receive an email with the data in some time.",
    "export_failed": "The data you requested could not be processed. Please try again later.",
    "selectAllError": "You can only select 1,000 sub-accounts at a time.",
    "max1000": "(Max 1,000)",
    "subAccountCount": "Sub-accounts count",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Are you sure you want to pause {count} reports?",
    "scheduleBulkResumeConfirm": "Are you sure you want to resume {count} reports?",
    "resume": "Resume",
    "pause": "Pause",
    "resumeSelected": "Resume selected",
    "pauseSelected": "Pause selected",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} reports selected",
    "selectAllXReports": "Select all {count} reports",
    "scheduleStatus": "Schedule status",
    "scheduleSearchPlaceholder": "Search using email or location name",
    "subAccountsPerPage": "Sub-accounts per page",
    "previous": "Previous",
    "scheduleBulkAction": "Schedule bulk action",
    "all": "All",
    "active": "Active",
    "paused": "Paused",
    "scheduleUpdatedSuccessfully": "Schedule updated successfully",
    "saveChanges": "Save changes",
    "pauseSchedulesTitle": "Pause active scheduled reports",
    "pauseSchedulesDescription": "Click to pause currently active reports.",
    "pauseSchedulesAlert": "This will only affect accounts that are currently active.",
    "pauseAllSchedulesBtnText": "Pause all scheduled reports",
    "autoScheduleTitle": "Auto-schedule for new accounts",
    "autoScheduleLabel": "Automatically create scheduled reports when a new sub-account is added.",
    "autoScheduleAlert": "Disable this if you want to manually configure for new accounts.",
    "autoScheduleEnabledForNewAccounts": "Auto-schedule enabled for new accounts",
    "autoScheduleDisabledForNewAccounts": "Auto-schedule disabled for new accounts",
    "deleted": "Deleted",
    "locationPaused": "Location paused",
    "scheduleSettingsModalTitle": "Schedule report settings",
    "selectAllSchedules": "Select all schedules",
    "selectScheduleForLocation": "Select schedule for {location}",
    "openSettings": "Open settings",
    "resumeScheduleForLocation": "Resume schedule for {location}",
    "pauseScheduleForLocation": "Pause schedule for {location}",
    "actions": "Actions",
    "deselectAll": "Deselect all",
    "scheduleBulkActionResumeSuccess": "Bulk activation in progress — hold off on new actions",
    "scheduleBulkActionPauseSuccess": "Pausing reports — wait before taking more actions",
    "bulkActionCreationError": "Another bulk action is in progress. Try again in a moment.",
    "bulkActionInProgress": "Bulk action already in progress",
    "scheduledReports": "Scheduled reports",
    "scheduleBulkActionCompleted": "Bulk action completed successfully",
    "pauseAllSchedulesModalTitle": "Pause reports?",
    "pauseAllSchedulesModalText": "This will pause all active scheduled reports across sub-accounts.",
    "addLocationIdsPlaceholder": "Add location IDs you want to transfer...",
    "helloWorld": {
      "count": "Count is {count}",
      "editIntro": "Edit",
      "editAction": "To test HMR",
      "checkOut": "Check out",
      "officialStarter": ", the official Vue + Vite starter",
      "install": "Install",
      "installDescription": "In your IDE for a better DX",
      "learnMore": "Click on the Vite and Vue logos to learn more"
    },
    "home": {
      "testMessage": "Hello! This is test homepage!"
    },
    "reports": {
      "incoming": "Incoming",
      "outgoing": "Outgoing",
      "duration": "Duration",
      "contactsCount": "Total contacts",
      "appointmentsCount": "Total appointments",
      "formSubmissions": "Form submissions",
      "surveySubmissions": "Survey submissions",
      "facebookFormSubmissions": "Facebook form submissions",
      "funnels": "Funnels",
      "websites": "Websites",
      "forms": "Forms",
      "surveys": "Surveys",
      "gbpMessages": "GBP messages",
      "facebookMessages": "Facebook messages",
      "instagramMessages": "Instagram messages",
      "reviews": "Reviews",
      "positives": "Positives",
      "negatives": "Negatives"
    },
    "timeOptions": {
      "00": "12:00 AM",
      "01": "1:00 AM",
      "02": "2:00 AM",
      "03": "3:00 AM",
      "04": "4:00 AM",
      "05": "5:00 AM",
      "06": "6:00 AM",
      "07": "7:00 AM",
      "08": "8:00 AM",
      "09": "9:00 AM",
      "10": "10:00 AM",
      "11": "11:00 AM",
      "12": "12:00 PM",
      "13": "1:00 PM",
      "14": "2:00 PM",
      "15": "3:00 PM",
      "16": "4:00 PM",
      "17": "5:00 PM",
      "18": "6:00 PM",
      "19": "7:00 PM",
      "20": "8:00 PM",
      "21": "9:00 PM",
      "22": "10:00 PM",
      "23": "11:00 PM"
    },
    "transferStatus": {
      "pending": "Pending",
      "processed": "Processed",
      "canceled": "Canceled",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "rejected": "Rejected",
      "failed": "Failed",
      "payment_pending": "Payment pending"
    }
    }
